import { LifeBuoy01 } from "@untitledui/icons";
import { useState } from "react";

import { Button } from "@/components/ui/buttons/button";
import { Gate } from "@/features/auth/gate";
import { ReportProblemModal } from "@/features/feedback/components/report-problem-modal";
import { PERMISSIONS } from "@/hooks/usePermissions";

/**
 * Fixed right-edge entry point for problem reports on authenticated pages.
 * Hidden unless the user holds {@link PERMISSIONS.ReportProblem}.
 */
export const ReportProblemButton = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<Gate permission={PERMISSIONS.ReportProblem}>
			<>
				<Button
					aria-label="Report a problem"
					className="fixed top-1/2 right-0 z-40 hidden -translate-y-1/2 rounded-l-lg rounded-r-none px-3 py-4 shadow-lg sm:inline-flex sm:[writing-mode:vertical-rl]"
					color="secondary"
					iconLeading={LifeBuoy01}
					onClick={() => setIsModalOpen(true)}
					size="sm"
				>
					Report problem
				</Button>

				<Button
					aria-label="Report a problem"
					className="fixed right-4 bottom-20 z-40 shadow-lg sm:hidden"
					color="secondary"
					iconLeading={LifeBuoy01}
					onClick={() => setIsModalOpen(true)}
					size="md"
				>
					Report
				</Button>

				<ReportProblemModal
					isOpen={isModalOpen}
					onClose={() => setIsModalOpen(false)}
				/>
			</>
		</Gate>
	);
};
